import React from 'react';
import { Calendar as PrimeCalendar } from 'primereact/calendar';

// PrimeReact's Calendar props are a strict discriminated union over
// selectionMode (single vs range vs multiple), which makes a single generic
// wrapper impractical to type. Treat it permissively.
const Cal = PrimeCalendar as unknown as React.ComponentType<any>;

export interface CalendarProps {
  testId?: string;
  /** Optional field label rendered above the calendar. */
  label?: string;
  required?: boolean;
  className?: string;
  onChange?: (e: { value: any; originalEvent?: any }) => void;
  [key: string]: any;
}

export const Calendar = ({ testId, label, required, className, onChange, ...props }: CalendarProps) => {
  const control = (
    <Cal
      data-testid={testId}
      className={className}
      onChange={onChange}
      {...props}
    />
  );

  if (!label) {
    return control;
  }

  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm font-medium">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {control}
    </div>
  );
};

export default Calendar;
